// 실시간 수신확인(ACK) 전달용 초경량 이벤트 버스.
// 전역 SSE 구독은 RealtimeNotifier 한 곳에서만 하고, 발신 화면(AdminPushPage)이 수신확인
// 내역을 실시간으로 목록에 쌓을 수 있도록 이 버스를 통해 ack 를 전달한다(추가 SSE 연결 방지).
const listeners = new Set();

export const adminPushBus = {
  subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
  emitAck(ack) {
    listeners.forEach((fn) => {
      try { fn(ack); } catch { /* 개별 리스너 오류는 무시 */ }
    });
  },
};
